import { Swiper, SwiperSlide } from 'swiper/react'
import { EffectFade, Navigation } from 'swiper'
import { Box, BoxProps } from '@mui/material'

import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/effect-fade'

import { SlideType } from '../../../_types'
import { ImageSlide, ImageScreen } from '../Slide/ImageSlide'

import { useState, useEffect } from 'react'

function getWindowDimensions() {
  const width = window.innerWidth
  const height = window.innerHeight
  return {
    width,
    height,
  }
}

export function useWindowDimensions() {
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  )
  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions())
    }
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return windowDimensions
}

export interface JumbotronProps extends BoxProps {
  slides: SlideType[]
  activeIndex: number
  allowTouchMove?: boolean
  onSelectNext?: any
  onSelectPrev?: any
  onSliderUpdates?: any
  isMobile?: boolean
  isLandscape?: boolean
  showIndicator?: boolean
}
export const Jumbotron: React.FC<JumbotronProps> = ({
  slides,
  activeIndex,
  allowTouchMove = false,
  onSliderUpdates,
  onSelectNext,
  onSelectPrev,
  isMobile,
  isLandscape,
  showIndicator = false,
}) => {
  const { width, height } = useWindowDimensions()
  console.log('herehere', { isMobile })
  return (
    <Box
      style={{
        maxWidth: width,
        height: isMobile && isLandscape ? height : undefined,
      }}
    >
      {showIndicator && (
        <Box
          className="jumbotron-slide-indicator"
          sx={{
            position: 'fixed',
            right: '5px',
            top: '5px',
            backgroundColor: 'black',
            opacity: 0.6,
            color: 'white',
            borderRadius: '6px',
            paddingX: '10px',
            paddingY: '5px',
            fontSize: '15px',
            zIndex: 100,
          }}
        >
          {activeIndex + 1}
        </Box>
      )}
      <Swiper
        className="Jumbotron"
        modules={[Navigation, EffectFade]}
        onSwiper={onSliderUpdates}
        slidesPerView={1}
        simulateTouch={allowTouchMove}
        allowTouchMove={allowTouchMove}
        onTouchEnd={(e: any) => {
          if (e?.swipeDirection === 'next') {
            onSelectNext()
          } else {
            onSelectPrev()
          }
        }}
      >
        {slides?.map((slide: SlideType, idx: number) => {
          if (isMobile && !isLandscape) {
            return (
              <SwiperSlide key={idx}>
                <ImageSlide isLandscape={isLandscape} slide={slide} />
              </SwiperSlide>
            )
          }
          return (
            <SwiperSlide key={idx}>
              <ImageScreen isMobile={isMobile} slide={slide} />
            </SwiperSlide>
          )
        })}
      </Swiper>
    </Box>
  )
}

export default Jumbotron
